// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"58ecf789","273":"1c54bccc","363":"95a8ce93"}[chunkId] + ".chunk.css";
};